export class BulkUploadDto {
  name!: string;
  section!: string;
  folder?: string;
  userId?: string;
  typeContrat?: string;
}
